import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ActivationErrorModal from '../../common/components/activation/ActivationErrorModal';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import TrialActivationSuccessContainer from './TrialActivationSuccessContainer';
import { activateTrial } from './activateTrial';
import { track } from '../../common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
const STATUSES = {
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
};
const HIDE_SUBTITLE_SCREENS = ['products-plans', 'service-hub-paywall'];

class TrialActivationModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trialActivationRequestStatus: STATUSES.LOADING,
      error: null,
      showTrialLoadingState: !!props.shouldHideSurvey
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const {
      activeTrials,
      expiredTrials,
      isMultiTrial,
      upgradeData
    } = this.props;
    track('trialModalInteraction', Object.assign({
      action: 'opened modal container'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    activateTrial({
      upgradeData,
      isMultiTrial,
      activeTrials,
      expiredTrials
    }).then(() => {
      if (this._isMounted) {
        this.setState({
          trialActivationRequestStatus: STATUSES.SUCCESS,
          showTrialLoadingState: false
        });
      }
    }).catch(err => {
      if (this._isMounted) {
        this.setState({
          trialActivationRequestStatus: STATUSES.ERROR,
          error: err
        });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      trialActivationRequestStatus,
      showTrialLoadingState
    } = this.state;

    const _this$props = this.props,
          {
      upgradeData,
      upgradeData: {
        screen
      },
      onSuccess,
      shouldHideSurvey,
      canViewNewSeats
    } = _this$props,
          successModalPassthroughProps = _objectWithoutPropertiesLoose(_this$props, ["upgradeData", "upgradeData", "onSuccess", "shouldHideSurvey", "canViewNewSeats"]);

    const showSubtitle = !HIDE_SUBTITLE_SCREENS.includes(screen);

    switch (trialActivationRequestStatus) {
      case STATUSES.LOADING:
        return null;

      case STATUSES.ERROR:
        track('trialModalInteraction', Object.assign({
          action: 'opening activation error modal'
        }, getUpgradeDataTrackingProperties(upgradeData), {
          trialId: upgradeData.trialId,
          duration: upgradeData.duration
        }));
        return /*#__PURE__*/_jsx(ActivationErrorModal, {});

      case STATUSES.SUCCESS:
        track('trialModalInteraction', Object.assign({
          action: 'opening activation success modal'
        }, getUpgradeDataTrackingProperties(upgradeData), {
          trialId: upgradeData.trialId,
          duration: upgradeData.duration
        }));
        return /*#__PURE__*/_jsx(TrialActivationSuccessContainer, Object.assign({
          onSuccess: onSuccess,
          upgradeData: upgradeData,
          showTrialLoadingState: showTrialLoadingState,
          showSubtitle: showSubtitle,
          shouldHideSurvey: shouldHideSurvey,
          canViewNewSeats: canViewNewSeats
        }, successModalPassthroughProps));

      default:
        return null;
    }
  }

}

TrialActivationModalContainer.defaultProps = {
  hideBackground: false
}; // @ts-expect-error type is too long

TrialActivationModalContainer.propTypes = Object.assign({
  activeTrials: PropTypes.array.isRequired,
  expiredTrials: PropTypes.array.isRequired,
  hideBackground: PropTypes.bool,
  isMultiTrial: PropTypes.bool,
  onSuccess: PropTypes.func,
  shouldHideSurvey: PropTypes.bool,
  successModalHeader: PropTypes.node,
  successModalSubText: PropTypes.node,
  successModalCtaText: PropTypes.node,
  showSuccessModalIllustration: PropTypes.bool,
  canViewNewSeats: PropTypes.bool
}, upgradeDataPropsInterface);
export default TrialActivationModalContainer;